( function( app ) {
  let boundMove = null;
  let currentCursorEl = null;

  function showCursor( section, cursorEl ) {
    cursorEl.removeAttribute( 'hidden' );
    cursorEl.classList.add( 'is-visible' );
    section.classList.add( 'cursor-is-watch-video' );
    currentCursorEl = cursorEl;
  }

  function hideCursor( section, cursorEl ) {
    if ( cursorEl ) {
      cursorEl.setAttribute( 'hidden', '' );
      cursorEl.classList.remove( 'is-visible' );
    }
    if ( section ) section.classList.remove( 'cursor-is-watch-video' );
    currentCursorEl = null;
  }

  function createMoveHandler( cursorEl ) {
    return function( e ) {
      cursorEl.style.left = e.clientX + 'px';
      cursorEl.style.top = e.clientY + 'px';
    };
  }

  function bindSection( section ) {
    const cursorEl = section.querySelector( '.click-to-play__cursor' );
    if ( !cursorEl ) return;

    function onEnter() {
      showCursor( section, cursorEl );
      boundMove = createMoveHandler( cursorEl );
      document.addEventListener( 'mousemove', boundMove, {passive: true} );
    }

    function onLeave() {
      document.removeEventListener( 'mousemove', boundMove );
      boundMove = null;
      hideCursor( section, cursorEl );
    }

    section.addEventListener( 'mouseenter', onEnter );
    section.addEventListener( 'mouseleave', onLeave );
  }

  function cleanupCursors() {
    document.querySelectorAll( '.click-to-play__cursor.is-visible' ).forEach( function( el ) {
      el.setAttribute( 'hidden', '' );
      el.classList.remove( 'is-visible' );
    } );
    document.querySelectorAll( '.click-to-play.cursor-is-watch-video' ).forEach( function( s ) {
      s.classList.remove( 'cursor-is-watch-video' );
    } );
  }

  const COMPONENT = {
    init: function() {
    },
    finalize: function() {
      if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) return;
      const mq = window.matchMedia( '(min-width: 1024px)' );
      const sections = document.querySelectorAll( '.click-to-play[data-has-popup-video]' );
      if ( mq.matches ) sections.forEach( bindSection );
      mq.addEventListener( 'change', function( e ) {
        if ( e.matches ) sections.forEach( bindSection );
        else cleanupCursors();
      } );
    },
  };

  app.registerComponent( 'click-to-play', COMPONENT );
} )( app );
